import React from 'react';
import PropTypes from 'prop-types';

import { Container } from 'components/core/Page';
import { Paragraph } from 'components/core/Typography';
import { Link } from 'components/core/Link';

import './PLPFooter.scss';

export function PLPFooter({ year }) {
	return (
		<footer className="plp-footer">
			<Container>
				<div className="footer-copyright">
					<Paragraph>
						&copy; {year} SelfStorage.com All rights reserved.&nbsp;
						<Link
							href="/legal/consumer"
							rel="nofollow"
						>
							Terms of Service
						</Link>
						&nbsp;and&nbsp;
						<Link
							href="/legal/consumer"
							rel="nofollow"
						>
							Privacy Policy
						</Link>
						.
					</Paragraph>
				</div>
			</Container>
		</footer>
	);
}

PLPFooter.propTypes = {
	year: PropTypes.number,
};

PLPFooter.defaultProps = {
	year: new Date().getFullYear(),
};
